// ===================================================================
// CustomFunctions.js - دوال مساعدة مشتركة
// ===================================================================
// هذا الملف يحتوي على دوال مساعدة يتم استخدامها عبر المشروع

import { map, layerCache } from './Map';

/**
 * الحصول على طبقة من الخريطة بناءً على اسمها
 * @param {string} layerName - اسم الطبقة المطلوبة
 * @returns {import('ol/layer/Layer').default|null} - الطبقة أو null إذا لم توجد
 */
export function getlayerByName(layerName) {
    if (!layerName) {
        console.warn('CustomFunctions: layerName is required');
        return null;
    }

    // ⚡ Level 3 Optimization: O(1) Lookup
    if (layerCache && layerCache.has(layerName)) {
        return layerCache.get(layerName);
    }

    // Fallback to manual search only if cache fails (safety first)
    const layers = map.getLayers();
    let foundLayer = null;

    layers.forEach((layer) => {
        if (layer.get('name') === layerName) {
            foundLayer = layer;
        }
    });

    if (foundLayer && layerCache) {
        layerCache.set(layerName, foundLayer);
    } else if (!foundLayer) {
        console.warn(`CustomFunctions: Layer "${layerName}" not found`);
    }

    return foundLayer;
}

/**
 * الحصول على جميع الطبقات المرئية
 * @returns {Array} - مصفوفة من الطبقات المرئية
 */
export function getVisibleLayers() {
    const layers = map.getLayers();
    const visibleLayers = [];

    layers.forEach((layer) => {
        if (layer.getVisible && layer.getVisible()) {
            visibleLayers.push(layer);
        }
    });

    return visibleLayers;
}

/**
 * تبديل رؤية الطبقة
 * @param {string} layerName - اسم الطبقة
 * @param {boolean} [visible] - الحالة المطلوبة (اختياري، سيتم التبديل إذا لم يُحدد)
 */
export function toggleLayerVisibility(layerName, visible) {
    const layer = getlayerByName(layerName);

    if (!layer) return;

    if (typeof visible === 'boolean') {
        layer.setVisible(visible);
    } else {
        layer.setVisible(!layer.getVisible());
    }
}

/**
 * التحكم في ظهور الأزرار العائمة على الخريطة (البوصلة، أداة الاستعلام، إلخ)
 * تستخدم غالباً على الجوال عند تفعيل الأدوات لتوفير مساحة
 * @param {boolean} isVisible - هل الأزرار مرئية؟
 */
export function setFloatingControlsVisible(isVisible) {
    if (isVisible) {
        document.body.classList.remove('hide-floating-controls');
    } else {
        document.body.classList.add('hide-floating-controls');
    }
}

/**
 * دالة مركزية لإغلاق السايدبار على الموبايل واستعادة جميع عناصر الواجهة
 */
export function closeSidebarOnMobile() {
    if (window.innerWidth <= 1024) {
        $('#sidebar').removeClass('open');
        document.body.classList.remove('mobile-menu-open');
        setFloatingControlsVisible(true);

        // منع العدسة من الظهور المفاجئ
        window.magnifierSuppressed = false;
    }
}

/**
 * الحصول على مرجع الخريطة
 * @returns {import('ol/Map').default} - كائن الخريطة
 */
export function getMap() {
    return map;
}

/**
 * دالة مساعدة لضمان فتح الشريط الجانبي وتحديث حجم الخريطة (Desktop)
 */
export function ensureSidebarVisible() {
    if (window.innerWidth >= 1024 && !document.body.classList.contains('left-sidebar-open')) {
        document.body.classList.add('left-sidebar-open');
        if (map) setTimeout(() => map.updateSize(), 400);
    }
}

/**
 * دالة مساعدة لضمان إغلاق الشريط الجانبي وتحديث حجم الخريطة (Desktop)
 */
export function ensureSidebarHidden() {
    if (window.innerWidth >= 1024 && document.body.classList.contains('left-sidebar-open')) {
        document.body.classList.remove('left-sidebar-open');
        if (map) setTimeout(() => map.updateSize(), 400);
    }
}

// Expose to window for global access
window.ensureSidebarVisible = ensureSidebarVisible;
window.ensureSidebarHidden = ensureSidebarHidden;
window.setFloatingControlsVisible = setFloatingControlsVisible;
